<template>

    <button v-if="alertExists"
        disabled
        :class="['active', 'btn', 'btn-alert', {'btn-blue': mode == 'listings'}, {'btn-red-bright': mode == 'sales'}]">
            <span :class="compact ? 'd-none d-lg-inline':''">{{ label }}</span> Alert Set &nbsp;<i class="fa-bell fas"></i>
    </button>
    <button v-else
        @click.prevent.stop="$emit('on-set-alert')"
        id="setAlertButton"
        :class="['btn', 'btn-alert', {'btn-blue': mode == 'listings'}, {'btn-red-bright': mode == 'sales'}]">
            Set <span :class="compact ? 'd-none d-lg-inline':''">{{ label }}</span> Alert &nbsp;<i class="fa-bell far"></i>
    </button>

</template>

<script>

import { mapGetters } from 'vuex';

export default {
    props: {
        compact: Boolean,
        mode: String,
    },
    computed: {
        ...mapGetters([
            'alertExists',
        ]),
        label() {
            if (this.mode === 'listings') {
                return 'Search';
            } else if (this.mode === 'sales') {
                return 'Sales';
            } else {
                return '';
            }
        },
    },
};
</script>

